export enum WidgetInputType {
  Text = 'InputText',
  Numeric = 'InputNumeric',
  Email = 'InputEmail',
  Currency = 'InputCurrency',
  SingleChoice = 'InputSingleChoice',
  MultipleChoice = 'InputMultipleChoice',
  Date = 'InputDate',
  DateInterval = 'InputDateInterval',
  // Commentato Address - Non implementato
  // Address = 'InputAddress',
  File = 'InputFile',
  UploadSigned = 'InputUploadSigned',
  Region = 'InputRegion',
  List = 'InputList',
  Boolean = 'InputBoolean',
  Captcha = 'InputCaptcha',
  Preview = 'InputPreview',
  CascadeSelect = 'InputCascadeSelect',
  MultiPreference = 'InputMultiPreference'
}
